import React from 'react';
import { shape, bool, string } from 'prop-types';

import Section from '~/views/common/Section';
import DataTable from '~/views/common/DataTable';
import BoolIcon from '~/views/common/BoolIcon';


const Contact = ({
    contact: {
        email,
        firstname,
        lastname,
        office,
        phone,
        private_email,
        private_name,
    },
}) => (
    <Section name="Contact">
        <DataTable.Body>
            <DataTable.Row header="Private Email">
                <BoolIcon value={private_email} />
            </DataTable.Row>

            <DataTable.Row header="Private Name">
                <BoolIcon value={private_name} />
            </DataTable.Row>

            <DataTable.Row header="Email">{ email }</DataTable.Row>
            <DataTable.Row header="First Name">{ firstname }</DataTable.Row>
            <DataTable.Row header="Last Name">{ lastname }</DataTable.Row>
            <DataTable.Row header="Office">{ office }</DataTable.Row>
            <DataTable.Row header="Phone">{ phone }</DataTable.Row>
        </DataTable.Body>
    </Section>
);

Contact.propTypes = {
    contact: shape({
        email: string,
        firstname: string,
        lastname: string,
        office: string,
        phone: string,
        private_email: bool,
        private_name: bool,
    }),
};

Contact.defaultProps = {
    contact: {
        email: '',
        firstname: '',
        lastname: '',
        office: '',
        phone: '',
        private_email: false,
        private_name: false,
    },
};

export default Contact;
